/* Publish by EComposer at 2026-10-23 18:12:15*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2pu5jmxmy2f"]=  window.__ectimmers["ecom-2pu5jmxmy2f"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2pu5jmxmy2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2pu5jmxmy2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4becl3ji3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4becl3ji3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wahz0tf08kf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wahz0tf08kf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koql9z8k9rp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koql9z8k9rp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1plzbsfmraa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1plzbsfmraa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rvbrlk5ughk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rvbrlk5ughk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hapru5dnzxt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hapru5dnzxt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rulpbs2cubn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rulpbs2cubn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1pmiztbed9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1pmiztbed9c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zo2seegn0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zo2seegn0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hviec94o1ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hviec94o1ue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9k2hei0uwu9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9k2hei0uwu9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bov9rsmxers').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bov9rsmxers', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2rotdpk7pk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2rotdpk7pk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ml0tziqccga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ml0tziqccga', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91pficpnh8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91pficpnh8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pyniyaa0tmj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pyniyaa0tmj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-56pe3a4ogtl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-56pe3a4ogtl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7j1n4mahwlf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7j1n4mahwlf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sdjxizeiy9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sdjxizeiy9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vu3ix6frrht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vu3ix6frrht', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-umjactagufi"]=  window.__ectimmers["ecom-umjactagufi"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-umjactagufi"]["x4ixgk2ag"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-umjactagufi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-umjactagufi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8g4aywsueqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8g4aywsueqm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxdz4qbzm7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxdz4qbzm7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llnczvapiyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llnczvapiyi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99gh2l2lr5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99gh2l2lr5s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z9t4gwms7f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z9t4gwms7f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9xxskg9yrnj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9xxskg9yrnj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zume81sgri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zume81sgri', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7cos2wezmy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7cos2wezmy', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3t3vrx4b9mo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3t3vrx4b9mo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2o73xifncf1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2o73xifncf1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6g8tawp07s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6g8tawp07s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bwmam6x8xoa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bwmam6x8xoa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gnko4qom87').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gnko4qom87', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahrqrylnal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahrqrylnal', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yg0abp9qtje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yg0abp9qtje', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u74uttu0s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u74uttu0s7', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9im4vijob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9im4vijob', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1d50xcc0b62h"]=  window.__ectimmers["ecom-1d50xcc0b62h"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-1d50xcc0b62h"]["98ryhrbw9"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-1d50xcc0b62h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1d50xcc0b62h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n0hjubekyg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0hjubekyg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z746jncplhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z746jncplhi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cajox474xrv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cajox474xrv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxzj285pm9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxzj285pm9l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmbl80qoa58').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmbl80qoa58', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lrudjs2gvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lrudjs2gvt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3siwh1qbjci').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3siwh1qbjci', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}